<template>
    <nav v-if="nav.items" class="navbar__menu">
        <ul>
            <li v-for="(menu, i) in nav.items" :key="`menu-item-${i}`">
                <NavbarMenuItem
                    v-if="menu"
                    :menu="menu"
                    :is-open="openMenuIndex === i"
                    @click="$emit('toggle-menu', i)"
                    @close-menu="$emit('close-menu')"
                />
            </li>
        </ul>
    </nav>
</template>

<script setup lang="ts">
    import type {NavbarConfig} from '@navbar-unlogged-types';
    import NavbarMenuItem from './NavbarMenuItem.vue';

    defineProps<{
        nav: NavbarConfig;
        openMenuIndex: number | null;
    }>();

    defineEmits<{
        'toggle-menu': [index: number];
        'close-menu': [];
    }>();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    /* mobile-first */
    .navbar__menu {
        height: 100%;
        padding: var(--joy-core-spacing-8) var(--joy-core-spacing-5);

        > ul {
            list-style: none;
            padding: 0;
            margin: 0;

            > li {
                &:not(:last-child) {
                    margin-bottom: var(--joy-core-spacing-8);
                }
            }
        }
    }

    /* desktop */
    @include mq.screen_sm(min) {
        .navbar__menu {
            position: static;
            padding: 0;

            > ul {
                list-style-type: none;
                width: 100%;
                display: flex;
                align-items: center;
                height: 100%;
                padding: 0;
                margin: 0;

                > li {
                    display: block;
                    list-style-type: none;
                    height: 100%;
                    border-bottom: none;

                    &:not(:last-child) {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
</style>
